import React, { useEffect, Component } from 'react';
import { useDrop } from 'react-dnd'

import classnames from 'classnames'

import './DropArea.css'

const DropAreaCon = (props, {children}) => {
  const { onDrop, onMouseInOut, overContent, overContentArg, acceptTypes, customStyle, horizontalDropArea, blockOverCon, placeholder } = props
  const { minHeight, opacity } = overContentArg
  let [{ isOver, canDrop }, drop] = useDrop({
    accept: acceptTypes,
    drop: onDrop,
    collect: monitor => ({
      isOver: !!monitor.isOver(),
      // canDrop: !!monitor.canDrop(),
    })
  })

  useEffect(() => {
    if (onMouseInOut) {
      onMouseInOut(isOver)
    }
  }, [isOver])

  const dropAreaStyle = {
    minHeight: minHeight ? minHeight : 200,
    opacity: opacity ? opacity : 0.5,
  }
  console.log('placeholder :>> ', placeholder);
  const globalDropAreaClassnames = classnames('global-drop-area', {
    'placeholder': placeholder,
  })

  return (
    <div ref={drop} className={globalDropAreaClassnames} style={customStyle ? customStyle : dropAreaStyle}>
      {/* {overContent(overContentArg)} */}
      {(children && !isOver) && (children)}
      { isOver && (overContent && !blockOverCon) && (
        overContent(overContentArg)
      )}
    </div>
  )
}

class DropArea extends Component {
  render() {
    return (
      <DropAreaCon {...this.props} children={this.props.children}></DropAreaCon>
    )
  }
}

export default DropArea